import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';

@autoinject
@transient()
export class Field {

    @bindable
    public label: string;

    @bindable
    public info: string = "";
}